export { default as tagsSet } from './tagsSet';

export const FILTERS = [
  {
    key: 'all',
    value: 'all'
  },
  {
    key: 'standard',
    value: 'standard'
  },
  {
    key: 'draggable',
    value: 'draggable'
  },
  {
    key: 'filters',
    value: 'filters'
  },
  {
    key: 'other sizes',
    value: 'other sizes'
  },
];

export const FILTERKEYS = {
  'standard'   : 'Standard',
  'draggable'  : 'Draggable',
  'filters'    : 'Filters',
  'other sizes': 'Other Sizes'
};


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/constants/index.js